import _ from 'lodash';
import { STUDY_STATUS } from './studyConstants';

/**
 * Computes how far a study has progressed through its recording window, for the progress bar. Yields 0 without a start, and for studies whose last history entry is started, paused or resumed takes the elapsed share of the start-to-stop duration clamped between 0 and 100, treating every other state as finished.
 *
 * @param study - Study carrying start, stop and lastStudyHistory.
 * @returns The progress percentage between 0 and 100.
 */
const calculateStudyProgress = (study: any) => {
  const { start } = study;
  if (!start) {
    return 0;
  }

  const { lastStudyHistory } = study;
  const progressStatues = [STUDY_STATUS.STARTED, STUDY_STATUS.PAUSED, STUDY_STATUS.RESUMED];
  if (lastStudyHistory && _.includes(progressStatues, lastStudyHistory.status)) {
    const { stop } = study;
    const duration = new Date(stop).valueOf() - new Date(start).valueOf();
    const startDate = new Date(start);
    let progress = Math.round(((new Date().valueOf() - startDate.valueOf()) / duration) * 100);
    progress = progress > 100 ? 100 : progress < 0 ? 0 : progress;
    return progress;
  }
  return 100;
};

export { calculateStudyProgress };
